import { getSessionData } from "src/session/sessionStore"
import { getCommonPagesDescriptions } from "./Common"
import { getBreadcrumbDescriptions } from "./components/breadcrumb"
import { getDashboardDescriptions } from "./components/Dashboard"
import { getFooterDescriptions } from "./components/footer"
import { getNavbarDescriptions } from "./components/navbar"
import { getSearchableTableDescriptions } from "./components/searchableTable"
import { getSidebarDescriptions } from "./components/Sidebar"
import { getSecurityDescriptions } from "./Pages/security"
import { getSettingsDescriptions } from "./Pages/Settings"
import { DefaultSettings, Descriptions } from "./types"
import { getLoaderDescriptions } from "./components/Loader"
import { getCustomerDescriptions } from "./Pages/Customer"
import { getServiceDescriptions } from "./Pages/Service"
import { getServiceContractDescriptions } from "./Pages/ServiceContract"
import { getContractPaymentDescriptions } from "./Pages/ContractPayment"
import { getAccountPayablesDescriptions } from "./Pages/AccountPayables"
import { getPayableContractDescriptions } from "./Pages/PayableContract"
import { getUserDescriptions } from "./Pages/User"
import { getAuthTokenValidatorDescriptions } from "./components/AuthTokenValidator"
import { getQuotationDescriptions } from "./Pages/Quotation"
import { getChatDescriptions } from "./Pages/Chat"

const systemLang = getSessionData().language ?? DefaultSettings.SYSTEM_LANG

export const SystemDescriptions: Descriptions = {
    PAGES: {
        CUSTOMER: getCustomerDescriptions(systemLang),
        CHAT: getChatDescriptions(systemLang),
        SERVICE: getServiceDescriptions(systemLang),
        SERVICE_CONTRACT: getServiceContractDescriptions(systemLang),
        CONTRACT_PAYMENT: getContractPaymentDescriptions(systemLang),
        ACCOUNT_PAYABLES: getAccountPayablesDescriptions(systemLang),
        PAYABLE_CONTRACT: getPayableContractDescriptions(systemLang),
        USER: getUserDescriptions(systemLang),
        QUOTATION: getQuotationDescriptions(systemLang),

        SECURITY: getSecurityDescriptions(systemLang),
        COMMON: getCommonPagesDescriptions(systemLang),

        SETTINGS: getSettingsDescriptions(systemLang),
    },
    COMPONENTS: {
        BREADCRUMB: getBreadcrumbDescriptions(systemLang),
        FOOTER: getFooterDescriptions(systemLang),
        NAVBAR: getNavbarDescriptions(systemLang),
        SIDEBAR: getSidebarDescriptions(systemLang),
        SEARCHABLE_TABLE: getSearchableTableDescriptions(systemLang),
        // ADD_PRODUCT: getAddProductDescriptions(systemLang),
        // PRODUCT_TRANSACTION: getProductTransactionsDescriptions(systemLang),
        DASHBOARD: getDashboardDescriptions(systemLang),
        // MODAL_PAYMENT: getPaymentModalDescriptions(systemLang),
        LOADER: getLoaderDescriptions(systemLang),
        AUTH_TOKEN_VALIDATOR: getAuthTokenValidatorDescriptions(systemLang),
    }
}
